import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const pdsProgressCss = ":host{--color-progress-fill:var(--pine-color-brand);--sizing-progress-bar-width:100%;-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;width:var(--sizing-progress-bar-width)}@-webkit-keyframes progressBar{0%{width:0}100%{width:var(--sizing-progress-bar-width)}}@keyframes progressBar{0%{width:0}100%{width:var(--sizing-progress-bar-width)}}.pds-progress{-ms-flex-align:center;align-items:center;background-color:var(--pine-color-background-container-disabled);border-radius:var(--pine-dimension-2xs);display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;height:var(--pine-dimension-xs);position:relative;width:100%}:host(.is-animated) progress,:host(.is-animated) progress::-webkit-progress-bar{-webkit-animation:progressBar 3s ease;animation:progressBar 3s ease;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}progress,progress::-webkit-progress-bar{background-color:transparent;border:0;height:var(--pine-dimension-xs);width:100%}progress::-webkit-progress-value{background-color:var(--color-progress-fill, var(--pine-color-brand));border-radius:var(--pine-dimension-2xs)}progress::-moz-progress-bar{background-color:var(--color-progress-fill, var(--pine-color-brand));border-radius:var(--pine-dimension-2xs)}.pds-progress__label{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.pds-progress__percentage{font-weight:var(--pine-font-weight-medium);-webkit-margin-start:calc(var(--pine-dimension-md) / 2);margin-inline-start:calc(var(--pine-dimension-md) / 2)}";

const PdsProgress$1 = /*@__PURE__*/ proxyCustomElement(class PdsProgress extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
        * Determines whether or not progress is animated.
        * @defaultValue false
        */
        this.animated = false;
        /**
        * Sets the progress fill pecentage and visually displayed when `show-percentage=true`.
        * @defaultValue 0
        */
        this.percent = 0;
        /**
        * Determines whether or not the percent value should be displayed as text.
        * @defaultValue false
        */
        this.showPercent = false;
    }
    render() {
        return (h(Host, { key: '2a7768cc769f62579bfee6d8f9e6109d10df0aaf', class: this.animated ? { 'is-animated': this.animated } : '' }, h("div", { key: '1eef3758e8c6e470f8cdd170e8d6c49e25bf9aa3', class: "pds-progress" }, h("label", { key: '5b75150a747a15379fdf0ee23b1be561e6d990e7', class: "pds-progress__label", htmlFor: this.componentId }, this.label), h("progress", { key: 'e20ad7d705d97ac11173ae515332fc1620a96328', id: this.componentId, max: "100", style: this.fillColor ? { '--color-progress-fill': this.fillColor } : {}, value: this.percent })), this.showPercent && h("div", { key: '8bafb39b5976149b80e720952e625f60f1e3c73c', class: "pds-progress__percentage" }, this.percent, "%")));
    }
    static get style() { return pdsProgressCss; }
}, [1, "pds-progress", {
        "animated": [4],
        "componentId": [1, "component-id"],
        "fillColor": [1, "fill-color"],
        "label": [1],
        "percent": [2],
        "showPercent": [4, "show-percent"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["pds-progress"];
    components.forEach(tagName => { switch (tagName) {
        case "pds-progress":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PdsProgress$1);
            }
            break;
    } });
}

const PdsProgress = PdsProgress$1;
const defineCustomElement = defineCustomElement$1;

export { PdsProgress, defineCustomElement };
//# sourceMappingURL=pds-progress.js.map

//# sourceMappingURL=pds-progress.js.map